import { render, staticRenderFns } from "./VWait.vue?vue&type=template&id=2050ccfd&"
import script from "./VWait.vue?vue&type=script&lang=js&"
export * from "./VWait.vue?vue&type=script&lang=js&"
import style0 from "./VWait.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports